import React from 'preact/compat';
import FormLabel from '@mui/material/FormLabel';

import colors from '../colors';
import DescriptionTooltip from './DescriptionTooltip';

export const Label = ({id, label, description}) => {
    const content = (
        <FormLabel
            id={id + "-label"}
            sx={{
                cursor: description ? 'help' : 'default',
                color: colors.primaryText,
                '&.Mui-focused': {
                    color: colors.primaryText
                },
                textAlign: 'left',
                marginBottom: '16px',
                fontSize: '14px',
            }}
        >
            {label}
        </FormLabel>
    );

    return description ?
        <DescriptionTooltip description={description}>{content}</DescriptionTooltip>:
        content;
};

export default Label;
